import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"
import type { GatsbyImageProps } from "gatsby-plugin-image"

const imgQuery = graphql`
  {
    mob: file(relativePath: { eq: "Banners/Hippo/mob.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
    tab: file(relativePath: { eq: "Banners/Hippo/tab.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
    desk: file(relativePath: { eq: "Banners/Hippo/desk.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
    large: file(relativePath: { eq: "Banners/Hippo/large.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
  }
`

export default function ImgHippo(props: Omit<GatsbyImageProps, "image">) {
  const data = useStaticQuery(imgQuery)

  const images = withArtDirection(getImage(data.large)!, [
    {
      media: "(max-width: 599.95px)",
      image: getImage(data.mob)!,
    },
    {
      media: "(max-width: 959.95px)",
      image: getImage(data.tab)!,
    },
    {
      media: "(max-width: 1279.95px)",
      image: getImage(data.desk)!,
    },
  ])

  return <GatsbyImage {...props} image={images} />
}
